if (!window.Eurus.loadedScript.has('gift-card-promo.js')) {
  window.Eurus.loadedScript.add('gift-card-promo.js');

  function playVideo(video) {
    if (!video) return;
    const promise = video.play();
    if (promise !== undefined) {
      promise.catch(function () {
        setTimeout(function () {
          video.play().catch(function () {});
        }, 100);
      });
    }
  }

  function initGiftCardPromo(root) {
    if (!root || root.dataset.gcpInit === 'true') return;
    root.dataset.gcpInit = 'true';

    var wraps = root.querySelectorAll('[data-gcp-video-wrap]');
    if (!wraps.length) return;

    wraps.forEach(function (wrap) {
      var video = wrap.querySelector('video');
      if (!video) return;

      video.muted = true;
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.setAttribute('webkit-playsinline', '');
      video.loop = true;

      function syncPausedState() {
        if (video.paused) {
          wrap.classList.add('is-paused');
          wrap.setAttribute('aria-pressed', 'true');
        } else {
          wrap.classList.remove('is-paused');
          wrap.setAttribute('aria-pressed', 'false');
        }
      }

      wrap.addEventListener('click', function () {
        if (video.paused) {
          wrap.removeAttribute('data-user-paused');
          playVideo(video);
        } else {
          wrap.setAttribute('data-user-paused', '');
          video.pause();
        }
        syncPausedState();
      });

      wrap.addEventListener('keydown', function (event) {
        if (event.key === 'Enter' || event.key === ' ') {
          event.preventDefault();
          wrap.click();
        }
      });

      video.addEventListener('play', syncPausedState);
      video.addEventListener('pause', syncPausedState);
      syncPausedState();
    });

    if (typeof IntersectionObserver === 'undefined') return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (!entry.isIntersecting) {
            wraps.forEach(function (wrap) {
              var video = wrap.querySelector('video');
              if (video) video.pause();
            });
            return;
          }

          wraps.forEach(function (wrap) {
            var video = wrap.querySelector('video');
            if (!video || wrap.hasAttribute('data-user-paused')) return;
            if (video.preload === 'none') video.preload = 'auto';
            if (video.readyState < 2) {
              video.addEventListener(
                'loadeddata',
                function onLoaded() {
                  video.removeEventListener('loadeddata', onLoaded);
                  playVideo(video);
                },
                { once: true }
              );
              video.load();
            } else {
              playVideo(video);
            }
          });
        });
      },
      { root: null, rootMargin: '0px', threshold: 0.2 }
    );

    observer.observe(root);
  }

  function initAll() {
    document.querySelectorAll('[data-gcp-video-center]').forEach(initGiftCardPromo);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    var root = event.target.querySelector('[data-gcp-video-center]');
    if (root) initGiftCardPromo(root);
  });
}
